<template>
    <div class="popup-images__row" data-gallery="">
        <a v-for="(image, index) in allImagesUrls"
           :key="index"
           :href="image"
           class="popup-images__item"
        >
            <img :data-src="image" alt="">
        </a>
    </div>
</template>

<script>
import Vue from "vue";
import app from "../../app";
import FavoriteButton from "../favorites/FavoriteButton.vue";

export default {
    name: "ImagesGallery",
    props: {
        allImagesUrls: {
            type: Array,
            default: () => []
        },
        id: {
            type: Number,
            default: null,
        },
        isComplex: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        this.initLightGallery();
    },
    methods: {
        initLightGallery() {
            const galleries = document.querySelectorAll("[data-gallery]");
            galleries.forEach((gallery => {
                let isComponentAdded = false;
                gallery.addEventListener('lgBeforeOpen', () => {
                    if (!isComponentAdded) {
                        const container = document.createElement('div');
                        container.className = 'custom-toolbar-element';
                        document.querySelector('.lg-container.lg-show .lg-wrapper').append(container);
                        new Vue({
                            store: app.$store,
                            render: h => h(FavoriteButton, {
                                props: {
                                    id: this.id,
                                    isCatalog: false,
                                    isComplex: this.isComplex
                                }
                            })
                        }).$mount(container);

                        isComponentAdded = true;
                    }
                });
            }));
        }
    }
}
</script>
